// Campus photo for /colleges/rowan-university: CC BY-SA 2.0, by Ben Schumin, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABunce_Hall_-01-_(50872834767).png), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/rowan-university/; credited under the photo.
const photo = {
    "slug": "rowan-university",
    "alt": "Bunce Hall with its white cupola and columned entrance at Rowan University in Glassboro, New Jersey",
    "src": "/colleges/rowan-university/campus-1600.webp",
    "srcSmall": "/colleges/rowan-university/campus-800.webp",
    "srcMid": "/colleges/rowan-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/rowan-university/og.jpg",
    "title": "Bunce Hall -01- (50872834767)",
    "author": "Ben Schumin",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABunce_Hall_-01-_(50872834767).png",
    "read": "2026-10-01"
};

export default photo;
